import {schema} from 'normalizr'
import {groupSchema, organizationSchema} from './organization'
import {userSchema} from './user'

export const pollSchema = new schema.Entity(
    'polls',
    {
        creator: new schema.Union(
            {
                user: userSchema,
                organization: organizationSchema,
                group: groupSchema,
            },
            '_type'
        ),
    },
    {
        idAttribute: 'idname',
    }
)
